import useStore from './_store';
import { mapState as rootMapState, mapActions as rootMapActions } from 'pinia';
import { mapState } from '@/store/helpers';
import { useUserStore, usePageStore, useChatStore } from '@/store';
import util from '@/common/util';
import infoAgent from '../md-form/info-agent.vue';
import infoForm from '../md-form/info-form.vue';
import global from '../../common/global';
import { normal } from '../defaultSpacing';
import { mapAsyncData } from '../../plugins/asyncData';
import { asyncData } from './asyncData';
import { leadTypes } from '@/common/const';

import spaceMixin from '@/modules/space-mixin';
import colorMixin from '@/modules/color-mixin';

export default {
    _getUseStore: useStore,
    mixins: [spaceMixin(), colorMixin()],
    data: function() {
        return {
            agentId: 0,
            title: '',
            privacyText: '',
            registerRole: leadTypes.Buyer,
            bgColor: '',
            contentBgColor: '',
            defaultMsg: '',
            onSubmitOption: {
                type: 'toast',
                toastMsg: '',
                toastDelay: 2000
            },
            questionnaire: {},
            formList: [],
            messageOption: {},
            submitOption: '',
            submitBgColor: '',
            lineFixed: false,
            ...normal,
            disclaimerWrapRef: null,
            formToastVisible: false,
        };
    },
    asyncData: mapAsyncData(asyncData),
    computed: {
        ...rootMapState(usePageStore, {
            agents: store => store.agents || [],
            licenseName: store => store.page?.licenseName
        }),
        ...rootMapState(useUserStore, {
            user: store => store.user
        }),
        ...mapState({
            formRequired: store => store.formRequired || {}
        }),
        newFormList() {
            const newFormList = [...this.formList];
            newFormList.push(this.messageOption);
            return newFormList;
        },
        isMobileSize() {
            return this.platform.isMobile;
        },
        paddingTop() {
            return (
                (this.isMobileSize ? this.mobileTopSpacing : this.topSpacing) +
                'px'
            );
        },
        marginBottom() {
            return (
                (this.isMobileSize ? this.mobileBtmSpacing : this.btmSpacing) +
                'px'
            );
        },
        agent({ agents, agentId = 0 }) {
            let agt = agents[agentId];
            if (agt && !agt.image) {
                agt.image =
                    'https://cdn.chime.me/image/fs/sitebuild/202457/7/original_fbb918b4-831d-43d3-8d96-68f8986a8e79.png';
            }
            return agt || {};
        }
    },
    watch: {
        user(value) {
            !value &&
                !util.isSSRServer &&
                this.$nextTick(() => {
                    this.calcLineFixed();
                });
        },
        agentId() {
            this.getAgentInfo();
        }
    },
    mounted() {
        this.calcLineFixed();
        global.scroll(this.calcLineFixed);
    },
    methods: {
        ...rootMapActions(useChatStore, {
            // updateChatPosition: 'updateChatPosition',
            resetChatPosition: 'resetChatPosition'
        }),
        ...rootMapActions(usePageStore, {
            getAgentInfo: 'getAgentInfo'
        }),
        onRef(e) {
            if (!util.isSSRServer) {
                this.disclaimerWrapRef = e;
            }
        },
        calcLineFixed() {
            const $lineContent = this.$refs.lineContent;
            if (!$lineContent || window.innerWidth < 1080) {
                this.lineFixed = false;
            } else {
                const bottom = $lineContent.getBoundingClientRect().bottom;
                const winHeight = window.innerHeight;
                if (bottom - winHeight > 0) {
                    this.lineFixed = true;
                } else {
                    this.lineFixed = false;
                }
            }
            if (this.lineFixed) {
                setTimeout(() => {
                    let $lineFormRef = this.$refs.lineFormRef;
                    let $linePlaceholderRef = this.$refs.linePlaceholderRef;
                    $linePlaceholderRef.style.height =
                        $lineFormRef.offsetHeight + 'px';
                    // this.updateChatPosition({
                    //     bottom: $lineFormRef.offsetHeight + 10 + 'px'
                    // });
                }, 10);
            } else {
                this.resetChatPosition();
            }
        },
        handleShowToast() {
            if (this.onSubmitOption && this.onSubmitOption.type === 'url') {
                window.open(
                    this.onSubmitOption.url,
                    this.onSubmitOption.target || '_blank'
                );
            } else {
                this.onSubmitOption &&
                    this.onSubmitOption.toastMsg &&
                    util.toast(
                        this.onSubmitOption.toastMsg,
                        (this.onSubmitOption &&
                            this.onSubmitOption.toastDelay) ||
                            2000
                    );
            }
        },
        formToastOption() {
            const option = this.onSubmitOption;
            return this.onSubmitOption.type === 'toast'
                ? {
                    showFooter: false,
                    showMark: true,
                    content: option.toastMsg,
                    duration: option.toastDelay || 3000,
                    confirmButtonStyle: {
                        backgroundColor: this.submitBgColor
                    },
                    iconStyle: {
                        color: this.submitBgColor
                    }
                }
                : {
                    showFooter: true,
                    showMark: true,
                    content: option.destinationMsg,
                    confirmButtonText: option.buttonText,
                    confirmButtonStyle: {
                        backgroundColor: this.submitBgColor
                    },
                    iconStyle: {
                        color: this.submitBgColor
                    }
                };
        },
        handleToastConfirm() {
            // jump to destination URL
            if (this.onSubmitOption.type === 'url') {
                window.open(
                    this.onSubmitOption.url,
                    this.onSubmitOption.target || '_blank'
                );
            }
        },
    },
    beforeMount() {
        if (this.formRequired.required !== undefined) {
            this.formList.forEach(item => {
                if (item.name == 'phone') {
                    item.required = this.formRequired.required;
                }
            });
        }
    },
    unmounted() {
        global.scroll(this.calcLineFixed, true);
    },
    components: {
        infoAgent,
        infoForm
    }
};
